var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 14,
    viewBox: "0 0 33 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_3705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4108 0.929688H4.40563C2.37158 0.929688 0.722656 2.57804 0.722656 4.61138V9.93324C0.722656 11.9666 2.37158 13.6149 4.40563 13.6149H28.4108C30.4448 13.6149 32.0938 11.9666 32.0938 9.93324V4.61138C32.0938 2.57804 30.4448 0.929688 28.4108 0.929688Z",
    fill: "#FFB3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8441 6.48689C25.5336 6.27365 25.1571 6.14819 24.7524 6.14819C23.6795 6.14819 22.8105 7.01687 22.8105 8.08939C22.8105 9.16194 23.6795 10.0306 24.7524 10.0306C25.1571 10.0306 25.5336 9.90516 25.8441 9.69192V9.9271H26.9453V6.24541H25.8441V6.4806V6.48689ZM24.8403 9.03963C24.2882 9.03963 23.8427 8.61626 23.8427 8.09253C23.8427 7.5688 24.2913 7.14544 24.8403 7.14544C25.3893 7.14544 25.8379 7.5688 25.8379 8.09253C25.8379 8.61626 25.3893 9.03963 24.8403 9.03963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7228 4.61133H9.56836V9.93319H10.7228V4.61133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8469 6.15381C20.4077 6.15381 19.9905 6.29177 19.7113 6.6681V6.25414H18.6133V9.93586H19.7238V8.00093C19.7238 7.44271 20.1003 7.16674 20.552 7.16674C21.0352 7.16674 21.3143 7.45525 21.3143 7.99149V9.93272H22.4155V7.59322C22.4155 6.73709 21.7347 6.15381 20.8469 6.15381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2113 6.48689C13.9008 6.27365 13.5243 6.14819 13.1196 6.14819C12.0467 6.14819 11.1777 7.01687 11.1777 8.08939C11.1777 9.16194 12.0467 10.0306 13.1196 10.0306C13.5243 10.0306 13.9008 9.90516 14.2113 9.69192V9.9271H15.3125V6.24541H14.2113V6.4806V6.48689ZM13.2074 9.03963C12.6553 9.03963 12.2099 8.61626 12.2099 8.09253C12.2099 7.5688 12.6584 7.14544 13.2074 7.14544C13.7564 7.14544 14.2051 7.5688 14.2051 8.09253C14.2051 8.61626 13.7564 9.03963 13.2074 9.03963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.02 6.7313V6.25146H15.8906V9.93319H17.0231V8.21464C17.0231 7.63447 17.6505 7.32401 18.0866 7.32401C18.0897 7.32401 18.096 7.32401 18.0992 7.32401V6.25146C17.6505 6.25146 17.2396 6.44279 17.02 6.7313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1152 8.62866C27.7324 8.62866 27.4219 8.93912 27.4219 9.3217C27.4219 9.70432 27.7324 10.0148 28.1152 10.0148C28.4979 10.0148 28.8085 9.70432 28.8085 9.3217C28.8085 8.93912 28.4979 8.62866 28.1152 8.62866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7741 4.61133H7.57889C7.57889 5.58977 7.12711 6.48983 6.34286 7.0794L5.86914 7.43378L7.70434 9.9363H9.21329L7.52553 7.63447C8.3255 6.83792 8.7741 5.76541 8.7741 4.61133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72183 4.61133H4.52344V9.9363H5.72183V4.61133Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_3705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4161,
    height: 12.6852,
    fill: "white",
    transform: "translate(0.699219 0.929199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.c93c6f33ab0191d807d30038b8a2aa79.svg";
export { ForwardRef as ReactComponent };